import { ComboboxItem } from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import { CancerConfig } from '@oncolens/oncolens-ui/lib/dto/config/Config';

function mapPathologies(config: CancerConfig[] | undefined) {
  return config?.reduce(
    (prev, next) => [
      ...prev,
      ...next.pathologies.map((pathology) => ({
        label: `${next.label} - ${pathology.label}`,
        value: pathology.value,
      })),
    ],
    [] as ComboboxItem[],
  );
}

function mapLocations(config: CancerConfig[] | undefined) {
  return config?.reduce(
    (prev, next) => [
      ...prev,
      ...next.locations.map((location) => ({
        label: `${next.label} - ${location.label}`,
        value: location.value,
      })),
    ],
    [] as ComboboxItem[],
  );
}

export { mapPathologies, mapLocations };
